var _defs, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40.55 48.41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .notes {\n        fill: currentColor;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "notes",
    d: "M10,20H26a2,2,0,0,0,0-4H10a2,2,0,0,0,0,4Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "notes",
    d: "M16,24H10a2,2,0,0,0,0,4h6a2,2,0,0,0,0-4Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "notes",
    d: "M10,12H26a2,2,0,1,0,0-4H10a2,2,0,0,0,0,4Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "notes",
    d: "M36.81,38.85q-.42-.14-.87-.24l-1-.31c.16-.12.32-.24.47-.37A7.92,7.92,0,0,0,36,26.77V10A10,10,0,0,0,26,0H10A10,10,0,0,0,0,10V34A10,10,0,0,0,10,44h3.45a2,2,0,1,0,0-4H10a6,6,0,0,1-6-6V10a6,6,0,0,1,6-6H26a6,6,0,0,1,6,6V24.29a8,8,0,0,0-7,13.93l-1,.36-.59.22a5.52,5.52,0,0,0-3.95,4.73.81.81,0,0,0,0,.16,4.73,4.73,0,0,0,4.72,4.72H35.83a4.74,4.74,0,0,0,4.72-4.75A5.44,5.44,0,0,0,36.81,38.85ZM30,28a4,4,0,1,1-4,4A4,4,0,0,1,30,28Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotes);
export default __webpack_public_path__ + "static/media/notes.bfe72b03.svg";
export { ForwardRef as ReactComponent };